//
// client-feature-change-dto.ts
//
// Copyright (c) 2017 by Curalate, Inc.
//

interface IClientFeatureChangeDTO {
    details: (string | null);
    featureId: string;
    wasRemoved: boolean;
    clientId: number;
    timestamp: number;
}
